export default __webpack_public_path__ + "static/media/gamony-wordmark.882573a2.svg";